import React, { useEffect, useState } from 'react'
import { analyticsFunction } from '../../api/analytics'

export default function InfoCards() {
  const [data, setData] = useState()

  const getAnalyticsFunctionApi = async () => {
    try {
      const data = await analyticsFunction()
      if (data) {
        setData(data)
        console.log("res", data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getAnalyticsFunctionApi()
  }, [])
  return (
    <section id="stats-cards" className="grid grid-cols-4 gap-6 mb-10">
      <div
        id="stat-products"
        className="bg-white rounded-xl shadow-sm border border-[#e5e7eb] px-7 py-6 flex items-center gap-5"
      >
        <div className="bg-[#eff6ff] flex items-center justify-center p-3 h-[52px] w-[52px] p-3 rounded-full">
          <i className="fa-solid fa-boxes-stacked text-2xl text-[#3b82f6]"></i>
        </div>
        <div>
          <div className="text-xl font-semibold text-[#1e293b]">
            {/* 1,280 */}
            {
              data?.totalProduct || null
            }
          </div>
          <div className="text-sm text-[#64748b] mt-1">Products</div>
        </div>
      </div>
      <div
        id="stat-orders"
        className="bg-white rounded-xl shadow-sm border border-[#e5e7eb] px-7 py-6 flex items-center gap-5"
      >
        <div className="bg-[#fef3c7] flex items-center justify-center p-3 h-[52px] w-[52px] p-3 rounded-full">
          <i className="fa-solid fa-cart-shopping text-2xl text-[#f59e42]"></i>
        </div>
        <div>
          <div className="text-xl font-semibold text-[#1e293b]">
            {
              data?.totalOrder || null
            }
          </div>
          <div className="text-sm text-[#64748b] mt-1">Orders</div>
        </div>
      </div>
      <div
        id="stat-users"
        className="bg-white rounded-xl shadow-sm border border-[#e5e7eb] px-7 py-6 flex items-center gap-5"
      >
        <div className="bg-[#d1fae5] flex items-center justify-center p-3 h-[52px] w-[52px] p-3 rounded-full">
          <i className="fa-solid fa-users text-2xl text-[#10b981]"></i>
        </div>
        <div>
          <div className="text-xl font-semibold text-[#1e293b]">
            {
              data?.totalUsers || null
            }
          </div>
          <div className="text-sm text-[#64748b] mt-1">Users</div>
        </div>
      </div>
      <div
        id="stat-vendors"
        className="bg-white rounded-xl shadow-sm border border-[#e5e7eb] px-7 py-6 flex items-center gap-5"
      >
        <div className="bg-[#e0e7ff] flex items-center justify-center p-3 h-[52px] w-[52px] rounded-full">
          <i className="fa-solid fa-building text-2xl text-[#6366f1]"></i>
        </div>
        <div>
          <div className="text-xl font-semibold text-[#1e293b]">
            {
              data?.totalCatgeory || null
            }
          </div>
          <div className="text-sm text-[#64748b] mt-1">Categories</div>
        </div>
      </div>
    </section>
  )
}
